import firebase from "../../firebase";
import { Document } from "../../useFirebase";

export enum NMEAQualityCode {
  NO_FIX = 0,
  GPS = 1,
  DGPS = 2,
  RTK_FIXED = 4,
  RTK_FLOAT = 5,
}

export const NMEAQualityPriority: Record<NMEAQualityCode, number> = {
  [NMEAQualityCode.NO_FIX]: 0,
  [NMEAQualityCode.GPS]: 1,
  [NMEAQualityCode.DGPS]: 2,
  [NMEAQualityCode.RTK_FLOAT]: 3,
  [NMEAQualityCode.RTK_FIXED]: 4,
};

export const NMEAQualityName: Record<NMEAQualityCode, string> = {
  [NMEAQualityCode.NO_FIX]: "No Fix",
  [NMEAQualityCode.GPS]: "GPS",
  [NMEAQualityCode.DGPS]: "DGPS",
  [NMEAQualityCode.RTK_FLOAT]: "RTK Float",
  [NMEAQualityCode.RTK_FIXED]: "RTK Fixed",
};

export interface Position {
  timestamp?: firebase.firestore.Timestamp;
  latitude: number;
  longitude: number;
  quality?: NMEAQualityCode;
}

export interface LogRate {
  fps: string;
  rate: string;
  size: string;
  threshold_value: string;
  above_threshold: number | boolean | "unchecked";
}

export interface Log {
  t?: string;
  name?: string;
  stable?: boolean;
  logging: boolean;
  rates_available?: boolean;
  rate?: Record<string, LogRate>;
}

export type InitialisationStatus = "active" | "inactive" | "complete";

export interface Initialisation {
  status: InitialisationStatus;
  message?: string[];
}

export interface Disk {
  available: string;
  disk: string;
  "min-till-full": string;
  mount: string;
  percentage: string;
  rate: string;
  size: string;
  used: string;
}

export interface Trinket {
  t: string;
  current_centre: number;
  current_max: number;
  current_mean: number;
  current_min: number;
  voltage: number;
}

export interface Configuration {
  "camera-angle": number;
  config: string;
}

export interface Strobe {
  error_count: number;
  flash_miss_count: number;
  flash_miss_delta: number;
}

export type Strobes = Record<string, Strobe>;

export interface Status extends Document {
  hostname: string;
  operator: string;
  initialisation: Initialisation;
  log: Log;
  position?: Position[];
  disk?: Disk;
  trinket?: Trinket;
  strobes?: Strobes;
  configuration?: Configuration;
  timestamp: firebase.firestore.Timestamp;
  serverTimestamp: firebase.firestore.Timestamp;
}
